import React from 'react';
import { useNavigate } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';

/**
 * Botón "Atrás" reutilizable para las páginas de la Intranet.
 * - Si se le pasa `to` (string), navega a esa ruta.
 * - Si no, ejecuta navigate(-1) (historial del navegador).
 */
const BackButton = ({ to, label = 'Atrás', className = '' }) => {
  const navigate = useNavigate();
  const handleClick = () => {
    if (to) navigate(to);
    else navigate(-1);
  };
  return (
    <button
      type="button"
      onClick={handleClick}
      data-testid="back-button"
      className={`inline-flex items-center gap-1 text-sm text-slate-500 hover:text-[#004E89] transition-colors mb-2 ${className}`}
    >
      <ArrowLeft className="w-4 h-4" />
      {label}
    </button>
  );
};

export default BackButton;
